import { useMutation, useQueryClient } from '@tanstack/react-query';

import { customAxios } from 'lib/axios';
import { User } from 'types';

const disableMfa = async (userId: string): Promise<User> => {
  const { data } = await customAxios.post<User>(`/users/${userId}/mfa/disable`);
  return data;
};

export const useDisableMfa = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: disableMfa,
    onSuccess: (data) => {
      queryClient.setQueryData(['auth-user'], data);
    },
  });
};
